export default "__VITE_ASSET__DL2zkK9x__"